module.exports = __webpack_public_path__ + "static/media/truck.d1812c30.svg";